import React from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { useWatchButton } from './useWatchButton';
var WatchButton = function (_a) {
    var _b;
    var children = _a.children, user = _a.user, _c = _a.disabled, disabled = _c === void 0 ? false : _c, isWatchingBack = _a.isWatchingBack, initialData = _a.initialData, onToggleWatchSuccess = _a.onToggleWatchSuccess;
    var _d = useWatchButton(user, (_b = initialData === null || initialData === void 0 ? void 0 : initialData.isWatching) !== null && _b !== void 0 ? _b : user.isWatching, isWatchingBack, disabled, onToggleWatchSuccess), text = _d.text, onClick = _d.onClick, biData = _d.biData, isLoading = _d.isLoading, isWatching = _d.isWatching, isSubscribed = _d.isSubscribed;
    return (React.createElement(ErrorBoundary, { debugComponent: "WatchButton" }, children({
        text: text,
        onClick: onClick,
        disabled: disabled,
        isLoading: isLoading,
        isWatching: isWatching,
        isSubscribed: isSubscribed,
        biData: biData,
    })));
};
WatchButton.displayName = 'WatchButton';
export default WatchButton;
//# sourceMappingURL=WatchButton.js.map